<template>
    <section class="container bg-white px-0 px-md-5 d-flex flex-column justify-content-center title-box pb-3">
        <slot></slot>
        <a class="text-center" :href="pageLink"><i class="fas fa-caret-down fa-3x text-success"></i></a>
    </section>
</template>

<script>
    export default {
        name: "MobileTitleSeparator",
        props: {
            pageLink: {
                type: String
            }
        }
    }
</script>

<style scoped>

</style>
